export * from './can-share';
export * from './is-sharable';
